import { useOutletContext } from "react-router-dom";
import { PageHeader } from "@/components/site/PageHeader";
import { ModelCard } from "@/components/site/ModelCard";
import { Stagger, Item } from "@/components/motion/Reveal";
import { TestDriveCTA } from "@/components/home/TestDriveCTA";

export default function Models() {
  const { vehicles, offers } = useOutletContext();
  return (
    <div data-testid="models-page">
      <PageHeader eyebrow="The Lineup" lines={["Every JETOUR,", "one showroom."]} sub="Ex-factory prices, key specifications and every variant we sell on West Canal Road. Tap a model for the full picture." />
      <section className="wrap pb-24 sm:pb-32">
        <Stagger className="grid gap-4 md:grid-cols-2 lg:grid-cols-3" gap={0.08}>
          {vehicles.map((v, i) => (
            <Item key={v.slug}><ModelCard vehicle={v} index={i} offer={offers.find((o) => o.vehicle_slug === v.slug)} /></Item>
          ))}
        </Stagger>
      </section>
      <TestDriveCTA vehicle={vehicles[1] || vehicles[0]} />
    </div>
  );
}
